import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

import LoadingSpinner from 'components/loading_spinner';

import {
  downloadLeasesAsCSV,
  downloadSalesAsCSV,
  retrieveLeases,
  retrieveSales
} from './store/actions/search';
import { changeLeasePage, changeSalePage } from './store/actions/query';

import CompsMapContainer from './comps_map_container';
import CompsMapList from './comps_map_list';
import CompsPageHeader from './header';
import LeasesTable from './lease/leases_table';
import SalesTable from './sale/sales_table';
import CompsFilterTopbar from './filters/comps_filter_topbar';
import CompsDeleteSavedSearch from './modals/delete_saved_search_modal';
import { COMP_VIEW_MAP, COMP_VIEW_LIST, COMP_VIEWS } from './comp_constants';
import { canExport, getCurrentTab, getCurrentView } from 'bundles/comps/index/store/selectors/ui';
import { getSelectedLeaseIds, getSelectedSaleIds } from 'bundles/comps/index/store/selectors/select_list';

export class CompsTab extends React.Component {
  static propTypes = {
    canExport: PropTypes.bool.isRequired,
    currentTab: PropTypes.oneOf(['lease', 'sale']).isRequired,
    currentView: PropTypes.oneOf(COMP_VIEWS).isRequired,
    downloadLeasesAsCSV: PropTypes.func.isRequired,
    downloadSalesAsCSV: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    leases: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
    retrieveLeases: PropTypes.func.isRequired,
    retrieveSales: PropTypes.func.isRequired,
    sales: PropTypes.array.isRequired,
    selectedLeaseIds: PropTypes.array,
    selectedSaleIds: PropTypes.array,
    onChangeLeasePage: PropTypes.func.isRequired,
    onChangeSalePage: PropTypes.func.isRequired
  };

  scrollPanel = React.createRef();

  scrollToTop() {
    this.scrollPanel.current.scrollTop = 0;
  }

  sale = () => this.props.currentTab === 'sale';

  selectedIds = () => {
    return this.sale() ? this.props.selectedSaleIds : this.props.selectedLeaseIds;
  }

  handlePageChange = (page) => {
    const { currentTab, onChangeLeasePage, onChangeSalePage, retrieveLeases, retrieveSales } = this.props;
    if (currentTab === 'lease') {
      onChangeLeasePage(page);
      retrieveLeases();
    } else {
      onChangeSalePage(page);
      retrieveSales();
    }

    this.scrollToTop();
  };

  render() {
    return (
      <React.Fragment>
        <CompsPageHeader />
        {this.renderFilterTopBar()}
        <div className="table-content">
          <div className="main-content" ref={this.scrollPanel}>
            {this.renderActiveTab()}
          </div>
        </div>
        <CompsDeleteSavedSearch />
      </React.Fragment>
    );
  }

  renderActiveTab() {
    const { currentView } = this.props;

    switch (currentView) {
    case COMP_VIEW_LIST:
      return (
        <React.Fragment>
          {this.renderResults()}
          {this.renderPagination()}
        </React.Fragment>
      );
    case COMP_VIEW_MAP:
      return (
        <div className="maps-container">
          <CompsMapList onPageChange={this.handlePageChange} />
          <div className="maps-view">
            <CompsMapContainer name="maps" />
          </div>
        </div>
      );
    }
  }

  renderNoResults() {
    return (
      <div className="no-results-panel">
        <FontAwesomeIcon className="text-muted my-4" icon={faSearch} size="5x"/>
        <h4 className="mt-4">
          <strong className="text-lg">No results found</strong>
        </h4>
        <p className="text-muted mb-4">Search with different criteria or create a New Comp</p>
      </div>
    );
  }

  renderResults() {
    const { isFetching, currentTab } = this.props;

    if (isFetching) {
      return <LoadingSpinner/>;
    }

    switch (currentTab) {
    case 'lease':
      return this.renderLeases();
    case 'sale':
      return this.renderSales();
    }
  }

  renderLeases() {
    const { leases } = this.props;
    if (leases.length === 0) {
      return this.renderNoResults();
    }
    return <LeasesTable />;
  }

  renderSales() {
    const { sales } = this.props;
    if (sales.length === 0) {
      return this.renderNoResults();
    }
    return <SalesTable />;
  }

  renderFilterTopBar() {
    const {
      currentTab,
      leases,
      meta,
      sales
    } = this.props;


    const pageData = {
      currentPage: meta.currentPage,
      itemCount: currentTab === 'lease' ? leases.length : sales.length,
      itemSingularLabel: 'comp',
      pageSize: meta.pageSize,
      totalCount: meta.totalCount
    };

    return (
      <CompsFilterTopbar pageData={pageData} />
    );
  }

  renderPagination() {
    const { currentTab, leases, sales, meta } = this.props;

    const comps = currentTab === 'lease' ? leases : sales;

    if (comps.length < meta.totalCount) {
      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={meta.currentPage}
            totalPages={meta.totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  ...state.search,
  canExport: canExport(state),
  currentTab: getCurrentTab(state),
  currentView: getCurrentView(state),
  selectedLeaseIds: getSelectedLeaseIds(state),
  selectedSaleIds: getSelectedSaleIds(state)
});

const mapDispatchToProps = {
  downloadLeasesAsCSV,
  downloadSalesAsCSV,
  retrieveLeases,
  retrieveSales,

  onChangeLeasePage: changeLeasePage,
  onChangeSalePage: changeSalePage
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsTab);
